import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./styles/dashboard.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { InventoryProvider } from "./Maindashboard/Context/InventoryContext";
import { QuotationProvider } from "./Maindashboard/Context/QuotationContext";
import { PurchaseOrderProvider } from "./Maindashboard/Context/PurchaseOrderContext";
import { BranchInventoryProvider } from "./Branchdashboard/Context/InventoryContext";
import { AuthProvider } from "./Maindashboard/Context/AuthContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BranchInventoryProvider>
      <QuotationProvider>
        <PurchaseOrderProvider>
          <AuthProvider>
            <InventoryProvider>
              <App />
            </InventoryProvider>
          </AuthProvider>
        </PurchaseOrderProvider>
      </QuotationProvider>
    </BranchInventoryProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
